import { defineComponent as _defineComponent } from 'vue'
import { addPlankToStore } from '@/apis/bujianStore'
import { buryPoint } from '@/apis/common/buryPoint'
import GAlertBorder from '@/components/common/g-alert-border.vue'
import GDragImage from '@/components/common/g-drag-image.vue'
import GBaseModal from '@/components/g-base-modal.vue'
import GTView from '@/components/translateComp/g-t-view.vue'
import { PartType } from '@/partTypes'
import store from '@/store'
import { AwaitStoreItem } from '@/store/modules/awaitPaibanStore'
import { StoreType } from '@/store/modules/awaitPaibanStore'
import { createTask } from '@/store/modules/progressNotice'
import { judgeIsMergeFrameDoor } from '@/util/LayoutFuncs'
import { addPropForPart, dealExpandSlot, rotatePart } from '@/util/LayoutTool'
import { matchHighlightBoardName, translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import { getOriPartByLayout, getPlankMatCode } from '@/util/plankCommonFuncs'
import { message } from 'ant-design-vue'
import { MessageBox } from 'element-ui'
import { computed, onMounted, ref, watch } from 'vue'

import { getPlankToAwaitStoreData } from './utlis'
import { createAwaitStoreDragStrategy } from './utlis/storeDragStrategy'
import { useStoreDragPlank } from './utlis/useStoreDragPlank'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    page: { default: 'paiban' },
    defaultScale: { default: 6 },
    scale: { default: 1 },
    plankLineWidth: { default: 1 },
    isMerge: { type: Boolean, default: true },
    activeBigpart: null,
    activeTempStorage: { type: Boolean, default: false }
  },
  emits: ['onStoreDone'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { page: 'paiban' | 'jinxi', defaultScale: number, scale: number, plankLineWidth: number, isMerge: boolean, activeBigpart?: any, activeTempStorage: boolean }





const keyword = ref('')
const isLoading = ref(false)
// 是否显示警示框
const isShowAlert = ref(false)
// 是否全选
const isSelectAll = ref(false)
/** 未入库小板提示弹窗 */
const isShowUnstockedModal = ref(false)
/** 弹窗内「不再提示未入库」勾选态（确认后才写入 store） */
const modalNoPrompt = ref(false)
/** checkLocalPlankStore 等待用户选择的 resolve */
let unstockedCheckResolve: ((pass: boolean) => void) | null = null

const unstockedModalOkText = computed(() =>
  modalNoPrompt.value
    ? 'common.ok'
    : 'arrangedPage.awaitPlankStore.pushAndOutput'
)

const storeState = computed(
  () =>
    store.state.awaitPaibanStore as NonNullable<
      typeof store.state.awaitPaibanStore
    >
)
const storeType = computed(() => storeState.value?.storeType)
const isLocal = computed(() => storeType.value === StoreType.notPutStore)
const isServe = computed(() => storeType.value === StoreType.alreadyPutStore)
// 未查找到相关板件
const isNotUsePlank = computed(
  () =>
    (props.activeBigpart || keyword.value) &&
    !filterData.value.length &&
    isServe.value &&
    showData.value.length
)

const showData = computed<AwaitStoreItem[]>(() => {
  const { localPlankStore, servePlankStore } = storeState.value!
  let result =
    storeType.value === StoreType.alreadyPutStore
      ? servePlankStore // 已入库
      : localPlankStore // 未入库
  return result
})

/** 根据条件过滤 */
const filterData = computed(() => {
  let result = showData.value
  result = filterOther(result)
  result = filterAllUsePlankData(result)
  result = filterDataByStoke(result, props.activeBigpart)
  if (isServe.value) {
    result = filterDataByKeyword(result, keyword.value)
    result = sort(result, storeState.value?.isViewCurrent)
  }
  return result
})

const isShowBox = computed(() => {
  return filterData.value.some((it) => it.isShow)
})

/** 监听localPlankStore,决定是否显示保存按钮，如果添加的板件都是prelayout内不存在的则不显示 */
const isShowSaveBtn = computed(() => {
  return filterData.value.some((it) => it.isShowChoose)
})

/** 监听本地缓存数据变化，更新是否全选状态 */
watch(
  () => storeState.value.localPlankStore.length,
  () => {
    handleSingleSelectChange()
  }
)

onMounted(() => {
  store.dispatch('awaitPaibanStore/getServePlankData')
})

function handleBury() {
  if (storeState.value?.isNoPromptPushStore) {
    buryPointApi('layout', 'not_tip_push_store')
  }
  if (storeState.value?.isViewCurrent) {
    buryPointApi('layout', 'only_view_current')
  }
}

function handleSubBury() {
  if (storeState.value?.isNoPromptPushStore) {
    buryPointApi('layout_sub', 'not_tip_push_store')
  }
  if (storeState.value?.isViewCurrent) {
    buryPointApi('layout_sub', 'only_view_current')
  }
}

/** 待排版库翻译函数 */
function t(k: string) {
  return translate('arrangedPage.awaitPlankStore.' + k)
}

/** 生成不能入库的文案提示 */
function getNotPushStoreMsg(data: AwaitStoreItem) {
  if (data.plank.specialType === 'supplus') return t('surplusCannotBeStorage')
  if (!data.isShowChoose) return t('plankHasBeenDeduction')
}

/** 切换选项 */
function handleChange(e: Event) {
  const target = e.target as HTMLDivElement
  const result = target.dataset.type as any
  if (result) {
    store.commit('awaitPaibanStore/setStoreType', Number(result))
  }
  if (result == '1') {
    buryPointApi(
      props.page === 'paiban' ? 'layout' : 'layout_sub',
      'not_push_store'
    )
  } else {
    buryPointApi(
      props.page === 'paiban' ? 'layout' : 'layout_sub',
      'already_push_store'
    )
  }
}

const {
  getCurrentDragTarget,
  handleDragClick: handleStoreDragClick,
  handleTargetPositionChange,
} = useStoreDragPlank({
  getImageOptions() {
    return {
      defaultScale: props.defaultScale,
      scale: props.scale,
      plankLineWidth: props.plankLineWidth,
    }
  },
  ...createAwaitStoreDragStrategy(t),
})

/** 点击暂存区的板件图片 */
async function handleDragClick(
  data: any,
  _e: MouseEvent,
  item: AwaitStoreItem,
  options: any
) {
  await handleStoreDragClick(data, item, options)
  buryPoint({
    function_module: 'await_store',
    function_point: 'drag_plank_to_page_plank',
  })
}

/**
 * 排序
 * @param isViewCurrent 是否只查看当前订单
 */
function sort(data: any[], isViewCurrent = false) {
  const orderIds = new Set<string | number>()
  store.state.paibanData.forEach((bigPlank) => {
    bigPlank.parts.forEach((plank: PartType) => {
      plank.orderId && orderIds.add(plank.orderId)
    })
  })
  // 为待排版库数据进行排序显示 和当前订单相同的板件显示在顶部
  // 当前订单的板件
  const frontList: AwaitStoreItem[] = []
  // 存在订单id但不是当前订单的板件
  const centerList: AwaitStoreItem[] = []
  // 空订单的板件
  const backList: AwaitStoreItem[] = []
  data.forEach((it: any) => {
    const { orderId } = it
    if (!orderId) return backList.push(it)
    // 存在订单id
    orderIds.has(it.orderId) ? frontList.push(it) : centerList.push(it)
  })
  const all = [...frontList, ...centerList, ...backList]
  // 查看当前板件如果找不到任何的订单id那么空订单所组成的列表为当前清单
  const isCurrent = orderIds.size ? frontList : backList
  return isViewCurrent ? isCurrent : all
}

/** 过滤搜索数据 */
function filterDataByKeyword(data: any[], keyword: string) {
  if (!keyword) return data
  return data.filter((item: any) => {
    return item.address.includes(keyword)
  })
}
/** 过滤相同材质颜色厚度数据 */
function filterDataByStoke(data: any[], activePlank: any) {
  if (!activePlank) return data
  const result = data.filter((item: any) => {
    return (
      getPlankMatCode(item) === activePlank.matCode &&
      item.thick == activePlank.thick &&
      (item.color === activePlank.texture ||
        activePlank.allColors.includes(item.color))
    )
  })
  return result
}

/** 一些其他的过滤条件 */
function filterOther(data: any) {
  const { participationPaibanPlank } = storeState.value
  return data.filter((plank: any) => {
    // 过滤出已经在排版页面的板件 已在页面上的不推荐显示出来
    return !participationPaibanPlank.includes(plank.partUniqueId)
  })
}

/** 过滤所有能用在整个排版页面的板件数据 */
function filterAllUsePlankData(data: any[]) {
  const stockKeys = store.state.finalDrawData
    .flatMap((item) => item.stockKeys)
    .concat(
      store.state.finalDrawData.map(
        ({ matCode, texture, thick }) => `${texture}:${matCode}:${thick}`
      )
    )
  const result = data.filter((plank: any) => {
    const { color, thick } = plank
    const stockKey = `${color}:${getPlankMatCode(plank)}:${thick}`
    return stockKeys.includes(stockKey)
  })
  return result
}

/** 从待排版库中删除存储的板子 */
function handleDeletefromStore() {
  const local = storeState.value?.localPlankStore ?? []
  const deleteData = [] as any
  const storeData = [] as any
  local.forEach((it) => {
    if (it.isSelect) {
      deleteData.push(it)
    } else {
      storeData.push(it)
    }
  })
  if (!deleteData.length)
    return message.warning(translate('common.pleaseSelectPlank'))
  // 点击删除要确认
  MessageBox.confirm(
    translate('common.deleteTip'),
    translate('common.warmTip'),
    {
      confirmButtonText: translate('common.confirm'),
      cancelButtonText: translate('common.cancel'),
      type: 'warning',
    }
  )
    .then(() => {
      try {
        store.commit('awaitPaibanStore/reSetLocalPlankStore', storeData)
        message.success(translate('common.deleteSuccess'))
        if (props.page === 'paiban') {
          buryPointApi('layout', 'del_await_store')
        } else {
          buryPointApi('layout_sub', 'del_await_store')
        }
      } catch {
        message.error(translate('common.deleteError'))
      }
    })
    .catch(() => {
      message.warning(translate('common.cancelDelete'))
    })
}
/**
 * 添加到待排版库
 * @param options.saveAllVisible 为 true 时入库所有可见且可入库的小板（弹窗「入库并输出」）
 */
async function handleSaveToStore(options?: {
  saveAllVisible?: boolean
}): Promise<boolean> {
  try {
    const local = storeState.value?.localPlankStore ?? []
    const storeData = options?.saveAllVisible
      ? local.filter((it) => it.isShow && it.isShowChoose)
      : local.filter((it) => it.isSelect && it.isShowChoose)
    if (!storeData.length) {
      message.warning(translate('common.saveToStoreTip'))
      return false
    }
    isLoading.value = true
    const planks = storeData.map((it) => it.plank)
    // 合并后的骨骼门在排版页是 1 块，进到待排版库需拆分成原来的 5 块
    const splicePlanks: any[] = []
    planks.forEach((plank: any) => {
      if (judgeIsMergeFrameDoor(plank)) {
        splicePlanks.push(...plank.frame_door_children)
      } else {
        splicePlanks.push(plank)
      }
    })
    // 需要保存最原始的板件数据 根据plankNum进行匹配
    let originPlanks = splicePlanks
      .map((plank) => {
        let originPlank = getOriPartByLayout(plank.oriPartUniqueId)
        if (originPlank) {
          originPlank = JSON.parse(JSON.stringify(originPlank))
          // 排版页只需要入库一份数据
          originPlank.amount = 1
          // 待排版库的排版页条码需要保证和排版页相同
          originPlank.plankNum = plank.plankNum
          originPlank.oriPlankNum = plank.oriPlankNum
          originPlank.oriPlankNumF = plank.oriPlankNumF
          originPlank.simplePlankNumF = plank.simplePlankNumF
          originPlank.simplePlankNum = plank.simplePlankNum
        }
        return originPlank
      })
      .filter((it) => it)
    const total = originPlanks.length
    let { task } = createTask(t('taskTitle'), total) as any
    const data = await getPlankToAwaitStoreData(originPlanks, task, false)
    task = null
    if (!data) {
      message.error(t('dataGenErr'))
      return false
    }
    const result = await addPlankToStore(data)
    if (result.status !== 1) {
      message.error(result.msg)
      return false
    }
    message.success(t('pushSuccess'))
    store.dispatch('awaitPaibanStore/getServePlankData')
    // 删除本地板件
    delAlreadyStoreLocalPlank(planks)
    // 精细排版板件入待排版库之后全局的数据也要修改，但是这里直接返回不保存也会造成方案被保存
    emits('onStoreDone', planks)
    buryPoint({
      function_module: 'await_store',
      function_point: 'batch_push_store',
    })
    if (props.page !== 'paiban') {
      buryPointApi('layout_sub', 'save_to_store')
    }
    return true
  } catch {
    message.error(t('pushErr'))
    return false
  } finally {
    isLoading.value = false
  }
}

/** 删除本地缓存中的本地板件数据 */
function delAlreadyStoreLocalPlank(planks: PartType[]) {
  const partIds = planks.map((item) => item.partUniqueId)
  // 过滤出还未入库的板件
  const result = storeState.value?.localPlankStore.filter(
    (plank) => !partIds.includes(plank.partUniqueId)
  )
  // 将入库的板件删除
  store.commit('awaitPaibanStore/reSetLocalPlankStore', result)
}

/**
 * 检查待排版库本地存储中是否存在未入库板件
 * 需要提示时弹出弹窗，返回 Promise，用户确认后 resolve(true) 才继续后续操作
 */
function checkLocalPlankStore(): boolean | Promise<boolean> {
  // 仅提醒可见且可入库的未入库小板（与「入库并输出」能力一致）
  const localPlank = storeState.value?.localPlankStore.some(
    (it) => it.isShow && it.isShowChoose
  )
  // 本地存储不存在板件和不提示都正常返回
  if (storeState.value?.isNoPromptPushStore || !localPlank) {
    return true
  }
  isShowAlert.value = true
  modalNoPrompt.value = false
  isShowUnstockedModal.value = true
  return new Promise((resolve) => {
    unstockedCheckResolve = resolve
  })
}

function resolveUnstockedCheck(pass: boolean) {
  isShowUnstockedModal.value = false
  unstockedCheckResolve?.(pass)
  unstockedCheckResolve = null
}

function handleUnstockedModalCancel() {
  resolveUnstockedCheck(false)
}

/** 入库并输出 / 确定 */
async function handleUnstockedModalOk() {
  if (modalNoPrompt.value) {
    store.commit('awaitPaibanStore/setIsNoPromptPushStore', true)
    if (props.page === 'paiban') {
      handleBury()
    } else {
      handleSubBury()
    }
    resolveUnstockedCheck(true)
    return
  }
  const ok = await handleSaveToStore({ saveAllVisible: true })
  if (!ok) return
  resolveUnstockedCheck(true)
}

/** 全选变化，子随动 */
function handleSelectAllChange() {
  storeState.value?.localPlankStore.forEach((item) => {
    item.isSelect = isSelectAll.value
  })
}
/** 子变化，改变全选状态 */
function handleSingleSelectChange() {
  isSelectAll.value = storeState.value?.localPlankStore.every(
    (item) => item.isSelect
  )
}

const plankStoreRef = ref<null | HTMLElement>(null)
function autoScrollToWaitedCompositionZone() {
  plankStoreRef.value?.scrollIntoView({
    behavior: 'smooth',
    block: 'end',
    inline: 'nearest',
  })
}
/**
 * 提取材料名称
 * @param {string} str - 原始字符串，例如 "18.9高光_多层实木(T01)"
 * @returns {string} - 返回中间的材料部分，例如 "多层实木"
 */
function extractMaterialName(str: string) {
  if (typeof str !== 'string') return ''
  const match = str.match(/_(.+?)(?:\(|$)/)
  return match ? match[1].trim() : ''
}
/**
 * @description 待排版库高光名称显示
 */
function awaitHighGlossName(title: string) {
  return title.replace(
    '高光_',
    `${matchHighlightBoardName(extractMaterialName(title), false)}_`
  )
}
expose({
  getCurrentDragTarget,
  checkLocalPlankStore,
  autoScrollToWaitedCompositionZone,
})

return { __sfc: true,props, emits, keyword, isLoading, isShowAlert, isSelectAll, isShowUnstockedModal, modalNoPrompt, unstockedCheckResolve, unstockedModalOkText, storeState, storeType, isLocal, isServe, isNotUsePlank, showData, filterData, isShowBox, isShowSaveBtn, handleBury, handleSubBury, t, getNotPushStoreMsg, handleChange, getCurrentDragTarget, handleStoreDragClick, handleTargetPositionChange, handleDragClick, sort, filterDataByKeyword, filterDataByStoke, filterOther, filterAllUsePlankData, handleDeletefromStore, handleSaveToStore, delAlreadyStoreLocalPlank, checkLocalPlankStore, resolveUnstockedCheck, handleUnstockedModalCancel, handleUnstockedModalOk, handleSelectAllChange, handleSingleSelectChange, plankStoreRef, autoScrollToWaitedCompositionZone, extractMaterialName, awaitHighGlossName, GAlertBorder, GDragImage, GBaseModal, GTView, StoreType, judgeIsMergeFrameDoor }
}

})